export default __webpack_public_path__ + "static/media/KUVIKBrochure.34bbcf8f.pdf";